import SettingFrame from "../../../../components/@settings/SettingFrame";
import UpdateCustomField from "../../../../components/@custom_fields/UpdateCustomField";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CustomFieldUpdatePage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <UpdateCustomField
                routeType={routeType}
            />
        </SettingFrame>
    )
}       